import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod/v3'
import { TasksPage } from '@/pages/tasks/TasksPage'

// Reuses the canonical Tasks page inside the Employee Center shell so the
// employee stays in the EC nav. Search schema mirrors the top-level /tasks
// route so deep-links (view/tab) survive validation.
const tasksSearchSchema = z.object({
  view: z.enum(['board', 'list', 'calendar']).optional(),
  tab: z.enum(['all', 'me', 'members', 'agents']).optional(),
})

function EmployeeTasksRoute() {
  // Employees only ever see their own assigned tasks.
  return <TasksPage assignedToMeOnly />
}

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/employee-center/tasks',
)({
  component: EmployeeTasksRoute,
  validateSearch: tasksSearchSchema,
  staticData: { employeeCenterLayout: 'fullBleed' },
})
